document.addEventListener("DOMContentLoaded", function () {
  // Hide Reamaze functionality
  function waitForReamazeWidget() {
    const checkInterval = setInterval(() => {
      const reamazeWidget = document.querySelector("#reamaze-widget");
      const reamazeWidgetLabelContainer = document.querySelector(
        "#reamaze-widget-label-container"
      );

      if (reamazeWidget) {
        clearInterval(checkInterval);
        initializeObservation(reamazeWidget, reamazeWidgetLabelContainer);
      }
    }, 500);
  }

  function initializeObservation(reamazeWidget, reamazeWidgetLabelContainer) {
    function toggleReamazeWidget(element) {
      if (
        element.hasAttribute("open") ||
        element.classList.contains("active")
      ) {
        if (reamazeWidget) {
          reamazeWidget.style.opacity = "0";
          setTimeout(() => (reamazeWidget.style.display = "none"), 500);
        }
        if (reamazeWidgetLabelContainer) {
          reamazeWidgetLabelContainer.style.opacity = "0";
          setTimeout(
            () => (reamazeWidgetLabelContainer.style.display = "none"),
            500
          );
        }
      } else {
        if (reamazeWidget) {
          reamazeWidget.style.display = "block";
          setTimeout(() => (reamazeWidget.style.opacity = "1"), 300);
        }
        if (reamazeWidgetLabelContainer) {
          reamazeWidgetLabelContainer.style.display = "block";
          setTimeout(
            () => (reamazeWidgetLabelContainer.style.opacity = "1"),
            300
          );
        }
      }
    }

    const mobileDrawer = document.querySelector(
      "details.mobile-toggle-wrapper"
    );
    const sidePanels = document.querySelectorAll(".side-panel");
    const productDrawer = document.querySelector(".side-panel.product-drawer");

    if (mobileDrawer) toggleReamazeWidget(mobileDrawer);
    sidePanels.forEach((sidePanel) => toggleReamazeWidget(sidePanel));
    if (productDrawer) toggleReamazeWidget(productDrawer);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "open" &&
          mutation.target === mobileDrawer
        ) {
          toggleReamazeWidget(mutation.target);
        }
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class" &&
          (Array.from(sidePanels).includes(mutation.target) ||
            mutation.target === productDrawer)
        ) {
          toggleReamazeWidget(mutation.target);
        }
      });
    });

    if (mobileDrawer) observer.observe(mobileDrawer, { attributes: true });
    sidePanels.forEach((sidePanel) =>
      observer.observe(sidePanel, { attributes: true })
    );
    if (productDrawer) observer.observe(productDrawer, { attributes: true });

    if (reamazeWidget) {
      reamazeWidget.style.transition = "opacity 0.5s ease-in-out";
    }
    if (reamazeWidgetLabelContainer) {
      reamazeWidgetLabelContainer.style.transition = "opacity 0.5s ease-in-out";
    }
  }

  waitForReamazeWidget();

  // Variant swatches functionality
  function applyStickyStyles() {
    const stickySelects = document.querySelectorAll(
      ".variant-selects--sticky .variations"
    );
    stickySelects.forEach(function (element) {
      element.style.overflowX = "auto";
      element.style.overflowY = "hidden";
      element.style.display = "flex";
      element.style.flexWrap = "nowrap";
      element.style.webkitOverflowScrolling = "touch";
      element.style.scrollbarWidth = "thin";
      element.style.scrollbarColor = "#888 #f1f1f1";
      element.style.cursor = "grab";
      element.style.userSelect = "none";
    });

    const productFormInputs = document.querySelectorAll(
      ".variant-selects--sticky .product-form__input--block"
    );
    productFormInputs.forEach(function (element) {
      element.style.overflow = "visible";
      element.style.display = "flex";
      element.style.flexWrap = "nowrap";
    });

    const style = document.createElement("style");
    style.textContent = `
        .variant-selects--sticky .variations::-webkit-scrollbar {
          height: 6px;
        }
        .variant-selects--sticky .variations::-webkit-scrollbar-thumb {
          background-color: #888;
          border-radius: 3px;
        }
        .variant-selects--sticky .variations::-webkit-scrollbar-track {
          background-color: #f1f1f1;
        }
      `;
    document.head.appendChild(style);

    const stickyLabels = document.querySelectorAll(
      '.variant-selects--sticky .product-form__input--block input[type="radio"] + label'
    );
    stickyLabels.forEach(function (label) {
      label.style.height = "auto";
      label.style.minHeight = "110px";
      label.style.width = "155px";
      label.style.flex = "0 0 auto";
      label.style.display = "flex";
      label.style.flexDirection = "column";
      label.style.justifyContent = "center";
      label.style.alignItems = "center";
      label.style.userSelect = "none";
      label.style.boxShadow = "0px 2px 5px rgba(0, 0, 0, 0.2)";
      label.style.border = "1px solid lightgrey";
      label.style.padding = "10px";
      label.style.boxSizing = "border-box";
    });

    const fieldsets = document.querySelectorAll(
      ".variant-selects--sticky fieldset"
    );
    fieldsets.forEach((fieldset) => {
      fieldset.style.overflow = "visible";
    });

    document
      .querySelectorAll(
        ".variant-selects--sticky .variations label span strong"
      )
      .forEach(function (strongTag) {
        if (
          !strongTag.nextElementSibling ||
          strongTag.nextElementSibling.tagName !== "BR"
        ) {
          strongTag.insertAdjacentHTML("afterend", "<br>");
        }
      });
  }

  function removeSizeLabel() {
    const variantSelects = document.querySelector(".variant-selects--sticky");
    if (variantSelects) {
      const sizeLabel = variantSelects.querySelector(".form__label");
      if (sizeLabel) {
        sizeLabel.remove();
      }
    }
  }

  function applyDragScroll() {
    const scrollableElements = document.querySelectorAll(
      ".variant-selects--sticky .variations"
    );

    scrollableElements.forEach((ele) => {
      let isDown = false;
      let startX;
      let scrollLeft;
      let movedSignificantly = false;

      ele.addEventListener("pointerdown", (e) => {
        isDown = true;
        ele.style.cursor = "grabbing";
        startX = e.pageX - ele.offsetLeft;
        scrollLeft = ele.scrollLeft;
        movedSignificantly = false;
      });

      ele.addEventListener("pointerleave", () => {
        isDown = false;
        ele.style.cursor = "grab";
      });

      ele.addEventListener("pointerup", () => {
        isDown = false;
        ele.style.cursor = "grab";
        setTimeout(() => {
          movedSignificantly = false;
        }, 0);
      });

      ele.addEventListener("pointermove", (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - ele.offsetLeft;
        const walk = (x - startX) * 2;
        ele.scrollLeft = scrollLeft - walk;

        if (Math.abs(x - startX) > 5) {
          movedSignificantly = true;
        }
      });

      ele.addEventListener(
        "click",
        (e) => {
          if (movedSignificantly) {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        true
      );
    });
  }

  function applyAllChanges() {
    applyStickyStyles();
    removeSizeLabel();
    applyDragScroll();
  }

  applyAllChanges();

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "childList") {
        const addedNodes = mutation.addedNodes;
        for (let i = 0; i < addedNodes.length; i++) {
          if (
            addedNodes[i].nodeType === Node.ELEMENT_NODE &&
            (addedNodes[i].querySelector(".variant-selects--sticky") ||
              addedNodes[i].classList.contains("variant-selects--sticky"))
          ) {
            applyAllChanges();
            break;
          }
        }
      }
    });
  });

  const config = { childList: true, subtree: true };
  observer.observe(document.body, config);

  // Mobile-specific functionality
  if (window.innerWidth <= 768) {
    const processMutations = (mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === "childList") {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              processNode(node);
            }
          });
        }
      });
    };

    const processNode = (node) => {
      insertBreakAfterStrong(node);
      applyCustomStyles(node);

      if (node.children.length > 0) {
        Array.from(node.children).forEach((child) => {
          processNode(child);
        });
      }
    };

    const insertBreakAfterStrong = (node) => {
      if (node.matches("label > span > strong")) {
        node.insertAdjacentHTML("afterend", "<br>");
      }
    };

    const applyCustomStyles = (node) => {
      if (node.tagName === "LABEL" && node.parentNode.tagName === "FIELDSET") {
        node.style.cssText +=
          "height: auto !important; min-height: 110px !important; width: 155px !important;";
      }
      if (node.classList.contains("variations")) {
        node.style.cssText +=
          "overflow-x: auto !important; overflow-y: hidden !important;";
      }
      if (node.matches(".product-form__input.product-form__input--block")) {
        node.style.cssText +=
          "flex-wrap: nowrap !important; overflow: visible !important;";
      }
    };

    const mobileObserver = new MutationObserver(processMutations);
    mobileObserver.observe(document.body, { childList: true, subtree: true });

    document.querySelector(".form__label")?.remove();
  }

  // Free Shipping functionality
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      let amount_text = this.querySelector('.free-shipping--text span');
      let total = parseInt(this.dataset.cartTotal, 10);
      let minimum = Math.round(parseInt(this.dataset.minimum, 10) * (Shopify.currency.rate || 1));
      let percentage = 1;
      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');
      if (total < minimum) {
        percentage = total / minimum;

        if (amount_text) {
          let remaining = minimum - total,
            format = window.theme.settings.money_with_currency_format || "${{amount}}";
          amount_text.innerHTML = formatMoney(remaining, format);
        }
        this.remainingText.style.display = 'block';
        this.fullText.style.display = 'none';
      } else {
        this.remainingText.style.display = 'none';
        this.fullText.style.display = 'block';
      }

      this.style.setProperty('--percentage', percentage);
    }
  }

  if (!customElements.get('free-shipping')) {
    customElements.define('free-shipping', FreeShipping);
  }
});